module.exports = __webpack_public_path__ + "static/media/ravi.9b7d1120.png";